import * as ActionTypes from '../ActionTypes';

const componentInitialState = {
    isLoading: false,
    isLoadingOT: false,
    isLoadingLeaveWage: false,
    isLoadingTransportAllowance: false,
    isLoadingFoodAllowance: false,
    isLoadingPHAllowance: false,
    isLoadingBonusConfiguration: false,
    success: false,
    error: false,
    payroll_template_data: [],
    ot_data:[],
    payroll_setting_component_data:[],
    leave_wage_data: [],
    transport_allowance_data: [],
    food_allowance_data: [],
    ph_allowance_data: [],
    bonus_configuration_data: [],
    adjustment_components_data: [],
    isLoadingAdjustmentComponents: false,
}

export const PayrollTemplateReducer = function (state = componentInitialState, action) {
    switch (action.type) {
        case ActionTypes.PAYROLL_TEMPLATE_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.PAYROLL_TEMPLATE_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                payroll_template_data: action.payload?.data?.data
            };
        case ActionTypes.PAYROLL_TEMPLATE_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.PAYROLL_TEMPLATE_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.PAYROLL_TEMPLATE_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                payroll_template_data: action.payload?.data?.data
            };
        case ActionTypes.PAYROLL_TEMPLATE_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.PAYROLL_TEMPLATE_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.PAYROLL_TEMPLATE_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                payroll_template_data: action.payload?.data?.data
            };
        case ActionTypes.PAYROLL_TEMPLATE_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.PAYROLL_TEMPLATE_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.PAYROLL_TEMPLATE_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                payroll_template_data: action.payload?.data?.data
            };
        case ActionTypes.PAYROLL_TEMPLATE_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
            case ActionTypes.PAYROLL_SETTINGS_COMPONENT_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.PAYROLL_SETTINGS_COMPONENT_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                payroll_setting_component_data: action.payload?.data?.data
            };
        case ActionTypes.PAYROLL_SETTINGS_COMPONENT_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.LWF_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.LWF_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                labour_welfare_data: action.payload?.data?.data
            };
        case ActionTypes.LWF_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.LWF_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.LWF_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                labour_welfare_data: action.payload?.data?.data
            };
        case ActionTypes.LWF_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.LWF_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.LWF_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                labour_welfare_data: action.payload?.data?.data
            };
        case ActionTypes.LWF_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
            case ActionTypes.OT_GET_REQUEST:
            return {
                ...state,
                isLoadingOT: true,
                success: false,
                error: false,
            };
        case ActionTypes.OT_GET_SUCCESS:
            return {
                ...state,
                isLoadingOT: false,
                success: true,
                successMessage: action.payload?.message,
                ot_data: action.payload?.data?.data
            };
        case ActionTypes.OT_GET_ERROR:
            return {
                ...state,
                isLoadingOT: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.OT_ADD_REQUEST:
            return {
                ...state,
                isLoadingOT: true,
                success: false,
                error: false,
            };
        case ActionTypes.OT_ADD_SUCCESS:
            return {
                ...state,
                isLoadingOT: false,
                success: true,
                successMessage: action.payload?.message,
                ot_data: action.payload?.data?.data
            };
        case ActionTypes.OT_ADD_ERROR:
            return {
                ...state,
                isLoadingOT: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.OT_UPDATE_REQUEST:
            return {
                ...state,
                isLoadingOT: true,
                success: false,
                error: false,
            };
        case ActionTypes.OT_UPDATE_SUCCESS:
            return {
                ...state,
                isLoadingOT: false,
                success: true,
                successMessage: action.payload?.message,
                ot_data: action.payload?.data?.data
            };
        case ActionTypes.OT_UPDATE_ERROR:
            return {
                ...state,
                isLoadingOT: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.OT_DELETE_REQUEST:
            return {
                ...state,
                isLoadingOT: true,
                success: false,
                error: false,
            };
        case ActionTypes.OT_DELETE_SUCCESS:
            return {
                ...state,
                isLoadingOT: false,
                success: true,
                successMessage: action.payload?.message,
                ot_data: action.payload?.data?.data
            };
        case ActionTypes.OT_DELETE_ERROR:
            return {
                ...state,
                isLoadingOT: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.LEAVE_WAGE_GET_REQUEST:
        case ActionTypes.LEAVE_WAGE_ADD_REQUEST:
        case ActionTypes.LEAVE_WAGE_UPDATE_REQUEST:
        case ActionTypes.LEAVE_WAGE_DELETE_REQUEST:
            return {
                ...state,
                isLoadingLeaveWage: true,
                success: false,
                error: false,
            };
        case ActionTypes.LEAVE_WAGE_GET_SUCCESS:
        case ActionTypes.LEAVE_WAGE_ADD_SUCCESS:
        case ActionTypes.LEAVE_WAGE_UPDATE_SUCCESS:
        case ActionTypes.LEAVE_WAGE_DELETE_SUCCESS:
            return {
                ...state,
                isLoadingLeaveWage: false,
                success: true,
                successMessage: action.payload?.message,
                leave_wage_data: action.payload?.data?.data
            };
        case ActionTypes.LEAVE_WAGE_GET_ERROR:
        case ActionTypes.LEAVE_WAGE_ADD_ERROR:
        case ActionTypes.LEAVE_WAGE_UPDATE_ERROR:
        case ActionTypes.LEAVE_WAGE_DELETE_ERROR:
            return {
                ...state,
                isLoadingLeaveWage: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };

        case ActionTypes.TRANSPORT_ALLOWANCE_GET_REQUEST:
        case ActionTypes.TRANSPORT_ALLOWANCE_ADD_REQUEST:
        case ActionTypes.TRANSPORT_ALLOWANCE_UPDATE_REQUEST:
        case ActionTypes.TRANSPORT_ALLOWANCE_DELETE_REQUEST:
            return {
                ...state,
                isLoadingTransportAllowance: true,
                success: false,
                error: false,
            };
        case ActionTypes.TRANSPORT_ALLOWANCE_GET_SUCCESS:
        case ActionTypes.TRANSPORT_ALLOWANCE_ADD_SUCCESS:
        case ActionTypes.TRANSPORT_ALLOWANCE_UPDATE_SUCCESS:
        case ActionTypes.TRANSPORT_ALLOWANCE_DELETE_SUCCESS:
            return {
                ...state,
                isLoadingTransportAllowance: false,
                success: true,
                successMessage: action.payload?.message,
                transport_allowance_data: action.payload?.data?.data
            };
        case ActionTypes.TRANSPORT_ALLOWANCE_GET_ERROR:
        case ActionTypes.TRANSPORT_ALLOWANCE_ADD_ERROR:
        case ActionTypes.TRANSPORT_ALLOWANCE_UPDATE_ERROR:
        case ActionTypes.TRANSPORT_ALLOWANCE_DELETE_ERROR:
            return {
                ...state,
                isLoadingTransportAllowance: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
        };
        case ActionTypes.FOOD_ALLOWANCE_GET_REQUEST:
        case ActionTypes.FOOD_ALLOWANCE_UPDATE_REQUEST:
            return {
                ...state,
                isLoadingFoodAllowance: true,
                success: false,
                error: false,
            };
        case ActionTypes.FOOD_ALLOWANCE_GET_SUCCESS:
        case ActionTypes.FOOD_ALLOWANCE_UPDATE_SUCCESS:
            return {
                ...state,
                isLoadingFoodAllowance: false,
                success: true,
                successMessage: action.payload?.message,
                food_allowance_data: action.payload?.data?.data
            };
        case ActionTypes.FOOD_ALLOWANCE_GET_ERROR:
        case ActionTypes.FOOD_ALLOWANCE_UPDATE_ERROR:
            return {
                ...state,
                isLoadingFoodAllowance: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
        };
        // --- PH Allowance Actions ---
        case ActionTypes.PH_ALLOWANCE_GET_REQUEST:
        case ActionTypes.PH_ALLOWANCE_ADD_REQUEST:
        case ActionTypes.PH_ALLOWANCE_UPDATE_REQUEST:
        case ActionTypes.PH_ALLOWANCE_DELETE_REQUEST:
            return {
                ...state,
                isLoadingPHAllowance: true,
                success: false,
                error: false,
            };
        case ActionTypes.PH_ALLOWANCE_GET_SUCCESS:
        case ActionTypes.PH_ALLOWANCE_ADD_SUCCESS:
        case ActionTypes.PH_ALLOWANCE_UPDATE_SUCCESS:
        case ActionTypes.PH_ALLOWANCE_DELETE_SUCCESS:
            return {
                ...state,
                isLoadingPHAllowance: false,
                success: true,
                successMessage: action.payload?.message,
                ph_allowance_data: action.payload?.data?.data
            };
        case ActionTypes.PH_ALLOWANCE_GET_ERROR:
        case ActionTypes.PH_ALLOWANCE_ADD_ERROR:
        case ActionTypes.PH_ALLOWANCE_UPDATE_ERROR:
        case ActionTypes.PH_ALLOWANCE_DELETE_ERROR:
            return {
                ...state,
                isLoadingPHAllowance: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.BONUS_CONFIGURATION_GET_REQUEST:
        case ActionTypes.BONUS_CONFIGURATION_UPDATE_REQUEST:
            return {
                ...state,
                isLoadingBonusConfiguration: true,
                success: false,
                error: false,
            };
        case ActionTypes.BONUS_CONFIGURATION_GET_SUCCESS:
        case ActionTypes.BONUS_CONFIGURATION_UPDATE_SUCCESS:
            return {
                ...state,
                isLoadingBonusConfiguration: false,
                success: true,
                successMessage: action.payload?.message,
                bonus_configuration_data: action.payload?.data?.data
            };
        case ActionTypes.BONUS_CONFIGURATION_GET_ERROR:
        case ActionTypes.BONUS_CONFIGURATION_UPDATE_ERROR:
            return {
                ...state,
                isLoadingBonusConfiguration: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.ADJUSTMENT_COMPONENTS_GET_REQUEST:
        case ActionTypes.ADJUSTMENT_COMPONENTS_ADD_REQUEST:
        case ActionTypes.ADJUSTMENT_COMPONENTS_UPDATE_REQUEST:
        case ActionTypes.ADJUSTMENT_COMPONENTS_DELETE_REQUEST:
            return {
                ...state,
                isLoadingAdjustmentComponents: true,
                success: false,
                error: false,
            };
        case ActionTypes.ADJUSTMENT_COMPONENTS_GET_SUCCESS:
        case ActionTypes.ADJUSTMENT_COMPONENTS_ADD_SUCCESS:
        case ActionTypes.ADJUSTMENT_COMPONENTS_UPDATE_SUCCESS:
        case ActionTypes.ADJUSTMENT_COMPONENTS_DELETE_SUCCESS:
            return {
                ...state,
                isLoadingAdjustmentComponents: false,
                success: true,
                successMessage: action.payload?.message,
                adjustment_components_data: action?.payload?.data?.data
            };
        case ActionTypes.ADJUSTMENT_COMPONENTS_GET_ERROR:
        case ActionTypes.ADJUSTMENT_COMPONENTS_ADD_ERROR:
        case ActionTypes.ADJUSTMENT_COMPONENTS_UPDATE_ERROR:
        case ActionTypes.ADJUSTMENT_COMPONENTS_DELETE_ERROR:
            return {
                ...state,
                isLoadingAdjustmentComponents: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };

        default:
            return state;
    }
}